export var altNamesTranslations = {
    AgencyWorker: { id: "ui-br-users.role.agencyWorker" },
    PublisherAdmin: { id: "ui-br-users.role.publisherAdmin" },
    PublisherGuarantor: { id: "ui-br-users.role.publisherGuarantor" },
    Superuser: {
        id: "ui-br-users.role.superuser",
    },
    CollectionsAdministrator: {
        id: "ui-br-users.role.collectionsAdministrator",
    },
    OnixCodetablesAdministrator: {
        id: "ui-br-users.role.onixCodetablesAdministrator",
    },
    Distributor: {
        id: "ui-br-users.role.distributor",
    },
    AdminLegalDeposits: {
        id: "ui-br-users.role.adminLegalDeposits",
    },
    LibrarianLegalDepositsMonographs: {
        id: "ui-br-users.role.librarianLegalDepositsMonographs",
    },
    LibrarianLegalDepositsPeriodicals: {
        id: "ui-br-users.role.librarianLegalDepositsPeriodicals",
    },
    ExportApiClient: {
        id: "ui-br-users.role.exportApiClient",
    },
};
export var getRolesTranslations = function (intl, key) {
    var translation = altNamesTranslations[key];
    if (!translation)
        return key;
    return intl.formatMessage(translation);
};
